import { render } from "./DarkModeBtn.vue?vue&type=template&id=15e87089&scoped=true"
import script from "./DarkModeBtn.vue?vue&type=script&lang=js"
export * from "./DarkModeBtn.vue?vue&type=script&lang=js"

import "./DarkModeBtn.vue?vue&type=style&index=0&id=15e87089&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e87089"]])

export default __exports__